import { Injectable, OnInit } from '@angular/core';
import { SettingsService } from '../.services/settings.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { Subject } from 'rxjs/Subject';

declare var test: any;
declare var RTCMultiConnection:any;
declare var getScreenConstraints:any;
declare var io:any;



@Injectable()
export class ConnectionService {
  users: Array<any> = [];
  newUsers: any = new BehaviorSubject(this.users);
  connection = new RTCMultiConnection();
  settings: SettingsService;

  streamList: Array <any> = [];
  jumpedOutList: Array <any> = [];
  incomingMessage = new BehaviorSubject({to:0,from:0,message:0}); //these default values are very much necessary.
  isHost = new BehaviorSubject<boolean>(false);
  cast = this.isHost.asObservable();
  userCast = this.newUsers.asObservable();
  incomingMessageCast = this.incomingMessage.asObservable();
  screenshareActive: boolean;





  sendControlMessage = () => {
    this.connection.sendCustomMessage({
      type: 'control', msg: {
        screenshare: this.settings.screenshareOpen.value,
        layout: this.settings.layout.value,
        primary: 'who is primary id',
        chatLocked: this.settings.chatLock.value,
        screenLocked: this.settings.screenshareLocked.value,
        primaryLocked: this.settings.primaryLocked.value,
        from: this.settings.getId()
      }
    });
  }

  pushMessage = (message) => {
    this.incomingMessage.next(message);
  }

  setHost = () => {
    this.isHost.next(true);
  }
  
  setScreenConstraints = (video, audio, screen) => {
    this.connection.session = {
      audio: audio,
      video: video,
      screen: screen
    }

    this.connection.sdpConstraints.mandatory = {
       OfferToReceiveAudio: audio,
        OfferToReceiveVideo: video
    }
    
    this.connection.mediaConstraits = {
      video: video,
      audio: audio
    }

    this.connection.mandatory = {
      OfferToReceiveAudio: audio,
      OfferToReceiveVideo: video
    }
  }

  setSocketURL = (URL) => {
    this.connection.socketURL = URL;
  }

  setSocketMessage = (msg) => {
    this.connection.socketMessageEvent = msg;
  }

  getConstraints = () => {
    return({audio: this.connection.session.audio, video: this.connection.session.video});
  }

  getScreenConstraints = () => {
     this.connection.getScreenConstraints = function(callback) {
          getScreenConstraints(function(error, screen_constraints) {
              if (!error) {
                  screen_constraints = this.connection.modifyScreenConstraints(screen_constraints);
                  callback(error, screen_constraints);
                  return;
              }
              throw error;
          });
      };
  }

  getLocalUserId = () => {
    return this.connection.userid;
  }

  getLocalVideoStream = () => {
    //cycle through this.connection.streamEvents and grab the first one with type local.
    return 0;
  }


  requestPrimary = (userId) => {
    this.connection.sendCustomMessage({type: 'primaryReq', msg: userId})
  }

  addUser = (id, streamid) => {
    this.users.push({id: id, streamId: streamid})
    this.newUsers.next(this.users);
  }

  removeUser = (streamId) => {
    let foundUserIndex = this.users.findIndex(x =>{
      return x.streamId == streamId;
    })
    if(foundUserIndex > -1) {
      this.users.splice(foundUserIndex, 1);
    }
  }

  addExtraData = (data) => {
    this.connection.extra = data;

  } 

  restoreVideo = (streamId) => {
   if(this.jumpedOutList[streamId]) {
    this.streamList.push(this.jumpedOutList[streamId]);
    this.updateVideoStreams();
   } else {console.log('jump restore failed')}
  }

  ejectVideo = (streamId) => {
    let found = this.streamList.find((x) => {return x.streamId == streamId});
    let newList = this.streamList.filter((x) => { return x.streamId !== streamId});

    this.jumpedOutList[streamId] = found;
    this.streamList = newList;
    this.updateVideoStreams();

    

    // -------------------stop/pause video feed. ----------------------
    //send out update to other clients to jump out the jumper

  }

  checkIsHost = () => {
    return(this.connection.isInitiator);
  }

  test = () => {
    console.log(this.users);
    console.log(this.connection)

  }

  getUserByName = (name) => {
    console.log('looking for user by name: ' + name )
    let index = this.users.find((x) => { return x.username === x});
    if(index > -1) {
      return(this.users[index]);
    }
  }

  getUserById = (id) => {
    return new Promise((resolve, reject) =>{
      let foundUser = this.users.find((x) => {
        return x.id === id;
      });

      if(foundUser) {
        resolve(foundUser);
      } else {
        reject(false);
      }
    });

    /*
    let index = this.users.findIndex((x) => { return x.id === id});
    if(index > -1) {
      return(this.users[index]);
    }
    */
  }
  
  getUserByStreamId = (streamId) => {
   
    
  }

  disconnect = () => {
     this.connection.close();
  }
  
  getElementWithStream = (streamId) => {

    let found = this.streamList.find((x) => { return x.streamId === streamId});
    if(found) {
      return(found);
    }
  }

  kickUser = (userId) => {
    this.getUserById(userId).then((user) => {
      let userObj = user as any;
      this.connection.sendCustomMessage({type: 'kick', msg: {user: userObj.username, from: this.settings.getId()}});
    }) //promise
  }

  getUsernameById = (userId) => {
    console.log(userId)
    console.log(this.users)
    let find = this.users.find(x =>{
      return x.id == userId;
    });
    if(find) {
      return find.username;
    }
  }

  updateNamePlate = (namePlate, userId) => {
    let find = this.users.find(x => {
      return x.id == userId;
    });

    if(find) {
      namePlate.innerHTML = find.username;
    }
  }

  updateVideoStreams = () => {	
    //remove element from v1_16
    //this version is used by JUMP IN/OUT function...
    //may break in instance of more than 5 video streams if so, copy IF condition in video.ts version
    for(let i=0; i < this.streamList.length; i++) {
        let window = document.getElementById(`v${i+1}_16`)
        let namePlate = window.getElementsByClassName('namePlate')[0];
        let userId = this.streamList[i].userId;
          window.appendChild(this.streamList[i].element);
          this.updateNamePlate(namePlate, userId);
          this.streamList[i].element.media.play();
       
    }	
    
  }

  takePrimary = (id) => {

      let swap = (input, index_A, index_B) => {
          var temp = input[index_A];
          input[index_A] = input[index_B];
          input[index_B] = temp;
      }

      let shift = (index) => {
        let filtered = this.streamList.filter((x) => {
          return x !== index;
        });
        filtered.unshift(index);
        this.streamList = filtered;
      }

      let found = this.streamList.findIndex((x) => {
        return x.userId === id;
      });

      if(found > -1) {
        //swap(this.streamList, found, 0);
        shift(this.streamList[found]);
        this.updateVideoStreams();

        //disable primary with delay
      }
  }

  announceName = (name, userId) => {
    console.log('announging name...' + name)
    this.connection.sendCustomMessage({type: 'announceName', msg: {name: name, userId: userId}});
  }


  
  join = (room) => {
    this.connection.openOrJoin(room);
   // this.settings.changeJumpedInStatus()
    setTimeout(() => {
      this.settings.setUserId(this.connection.userid);
      this.announceName(this.settings.username, this.connection.userid);
    }, 10000)
    
  }

  newScreenshareReceived = (ssId) => {
  
    let connection = this.connection.connection;
        this.settings.changeScreenshareOpenState(true);
  
    let newFrame = document.getElementById('screenshareWindow') as HTMLIFrameElement;

    //Tell Iframe to open screenshare
    setTimeout(()=> {
      newFrame.contentWindow.postMessage({type: "openScreenshare", screenshareId: ssId}, "*") //open the screenshare for the host in iframe
      this.settings.setScreenshareIsOpen(true);
    }, 3000)
  }

  screenshareReceived = (ssId) => {
    //depcirated
        //offload primary element
      let primary = document.getElementById('v1_16');
      let frame = document.createElement('iframe');
        frame.src = "/Screenshare.html";
        frame.style.width = "100%";
        frame.style.position = "absolute";
        primary.appendChild(frame);

        let newScreenshare = document.getElementById('screenshareWindow') as HTMLIFrameElement;
      setTimeout(()=> {
         //frame.contentWindow.postMessage({type: "joinScreenshare", screenshareId: ssId}, "*")
         newScreenshare.contentWindow.postMessage({type: "joinScreenshare", screenshareId: ssId}, "*")
      }, 3000)

  }

  jump = (id) => { 
    let myId = this.settings.getId();
    let videoElements = Array.from(document.getElementsByClassName('MVC-video'));

 
    let clear = () => {
      this.streamList.forEach(x => {
        let elem = x.element;
        let dump = document.getElementById('dump');
            dump.appendChild(elem);
      });
    }
    
    let existsInUsers = () => {
      let searchingForId = id; 
      let found = false;
      
      for(const user of this.users) {
        if(user.id == searchingForId) {
          found = true;
        }
      }
      return(found)
    }

    let existsInJumpedOut = () => {
      let searchingforId = id;
      let found = false;
      for(const user of this.jumpedOutList) {
        if(searchingforId == user.userId) {
          found = true;
        }
      }
      return(found);
    }

    let removeFromJumpedOut = () =>  {
      let idToRemove = id;
      let filter  = this.jumpedOutList.filter(x => {
        return x.userId != id;
      });
      this.jumpedOutList = filter;
    }


    let isMine = () => {
      if(id == myId) {
        return(true)
      } else {
        return(false)
      }
    }

    let refresh = () => {
      this.updateVideoStreams();
    }

    let restore = () => {
      let userToRestore = this.jumpedOutList.find((x) => {
        return x.userId == id;
      });

      if(userToRestore) {
        if(isMine()) {
          this.settings.changeJumpedInStatus(true);
         // this.settings.jumpedIn = true; 
          this.connection.sendCustomMessage({type: 'jumpIn', msg: {id: id}});
        }
        
        let noDuplicateInList = this.streamList.find(x =>  {
          return x == userToRestore;
        })
        if(!noDuplicateInList) {
          this.streamList.push(userToRestore)
          let newJumpedOutList = this.jumpedOutList.filter(x => {
            return x != userToRestore;
          })
          this.jumpedOutList = newJumpedOutList;
        }

      } else {
        console.log('could not find user to restore from jumpedoutlist...');
      }
    }

    let removeFromStreamList = () => {
        let find = this.streamList.find(x => {
          return x.userId == id;
        });
        if(find) {
          this.jumpedOutList.push(find);
            if(isMine()) { 
              this.settings.changeJumpedInStatus(false);
              //this.settings.jumpedIn = false;
              this.connection.sendCustomMessage({type: 'jumpOut', msg: {id: id}}); 
            }
          let filter = this.streamList.filter(x => {
            return x != find;
          })
          this.streamList = filter;
        }
    }

    if(existsInUsers()) {
        if(existsInJumpedOut()){
          clear();
          restore();
          refresh();
        } else {
          clear();
          removeFromStreamList();
          refresh();
        }   
    }    
  }



  init = () => {
    let connection = this.connection;
    
        connection.enableLogs = false;
        connection.iceServers = [];

        

       /*
        window.addEventListener("message", function(event){
          console.log('CLOSE SCREENAHRE EVENT REACHED PARENT')
        })
        */
       
       
        connection.iceServers.push({
          urls: "stun:turn1.e-sdn.com:3478"
        });

        
        connection.iceServers.push({
          urls: 'turn:turn1.e-sdn.com:5349',
          credential: 'TrustNo1_Slurm',
          username: 'enlighten'
        });

        connection.candidates = {
          turn: true,
          stun: false,
          host: false
        }
        
        
    
   //this.setSocketURL("https://rtcmulticonnection.herokuapp.com:443/");
    this.setSocketURL("https://video4.e-sdn.com:3124/");
    this.setScreenConstraints(true, true, false); //use values from SETTINGS
    this.setSocketMessage("audio-video-screen-demo");
    //this.getScreenConstraints();
 
    
    window.addEventListener("message", (e)=> {
      if(e.data.type == "closeScreenshare") {
        let screenshareWindow = document.getElementById('screenshareframe')
            console.log(screenshareWindow)
            
            //screenshareWindow.parentElement.removeChild(screenshareWindow);
            //this.updateVideoStreams();
      
      }
    })
    
     connection.getScreenConstraints = function(callback) {
          getScreenConstraints(function(error, screen_constraints) {
            console.log(screen_constraints)
              if (!error) {
                  
                  screen_constraints = connection.modifyScreenConstraints(screen_constraints);
                  callback(error, screen_constraints);
                  return;
              }
              throw error;
          });
      };

    
    connection.connectSocket(()=> {
      connection.socket.on(connection.socketCustomEvent, (message) => {
        
        switch(message.type) {
          case "closeScreenshare": {
            alert('close screenshare called')
            break;
          }

          case "jumpIn": {
              let id = message.msg.id;
              this.jump(id);
            break;
          }

          case "jumpOut": {
            let id = message.msg.id;
            this.jump(id);
            break;
          }

          case "primaryLockState": {
              let locked = this.settings.primaryLocked,
                  from = message.msg.from,
                  set = message.msg.setLocked;

                  if(from == connection.sessionid) {
                    this.settings.setPrimaryMode(set);
                  }
            break;
          }

          case "disableChat": {
            let from = message.msg.from;
            let set = message.msg.set;
            if(from == connection.sessionid) {
              this.settings.setChatLock(set);
            }
            break;
          }

          case "screenshareLockState": {
              let locked = this.settings.screenshareLocked,
                  from = message.msg.from,
                  set = message.msg.setLocked;

                  if(from == connection.sessionid) {
                    this.settings.setScreenshareLock(set);
                  }
            break;
          }

          case "changeView": {
            let from = message.msg.from,
                layout = message.msg.layout;

            if(from == connection.sessionid) {
              this.settings.changeLayout(layout);
            }
                    
                 //this.selectedLayoutName = 'boo'; //cant change this proprety from this component -- link with observable IN SETTINGS

            break;
          }

          case "screenshareReq": {
            console.log('RECEIVED REQ')
            let requester = message.msg.requesterId,
                screenshareId = message.msg.screenshareId,
                session = message.msg.session;
 
                if(session == this.connection.sessionid) {
                  if(this.getUserById(requester) && !this.screenshareActive) { 
                    this.screenshareActive = true;
                    this.newScreenshareReceived(screenshareId);
                    this.settings.changeLayout("Secondary");
                  } 
              }

            break;
          }
          case "announceName": {
            //user object doesn't originally have a username property, so this matches user's object with the userid and adds the username property to that user's object
            let findUser = this.getUserById(message.msg.userId).then((user)=>{
              if(user) {
                user['username'] = message.msg.name;
                this.newUsers.next(this.users); //update users-list
              }
            }).catch((err)=> {
              //do nothing or log error
            })
            /*
            let user = this.getUserById(message.msg.userId);
                user.username = message.msg.name;
             */      
            break;
          }

          case "broadcastUsers": {
              
            break;
          }

          case "hostBroadcast": { 
            let id = message.msg.id; 
            let screenshareId = message.msg.screenshareId; 
            let primaryId = message.msg.primaryId;
            
            

            //set primary
            if(this.connection.sessionid == id  && primaryId) {
              setTimeout(()=> {
                this.takePrimary(primaryId)
              }, 4000)
            }
          

            if(this.connection.sessionid == id && screenshareId && !this.screenshareActive && this.streamList.length > 0){ //this is the host's id 
              //need to stop new connections from re-ordering the layout or put screenshare z-index higher  
              this.screenshareActive = true; 
              this.screenshareReceived(screenshareId); 
              this.settings.changeLayout("Secondary"); 
               
            } 
            break; 
          } 
          
          case "primaryReq": {
            this.takePrimary(message.msg);
            break;
          }
          case "chat": {
            //translate messagem.msg.from (a user id) to a known username or disgard it.
            connection.addChatMessage(message.msg.from, message.msg.message)
            console.log(message)
            

            break;
          }
          case "chatMessage": {
            let from = message.msg.from;
            let msg = message.msg.message; 
            let to = message.msg.to;
            console.log('received chat message')
            
            this.pushMessage({to: to, from: from, message: msg});
            break;
          }

          case "kick": {
            let user = message.msg.user;
            let from = message.msg.from;

            if(from == connection.sessionid) {
              console.log(user + ' kicked by host');
              //add notifiaction to chat.
              if(user == this.settings.getUsername()) {
                console.log('You have been disconnected by the host')
                //add error to error object / hide all elements
                this.disconnect();

                setTimeout(()=>{
                  location.reload();
                }, 6000)
              }
            }

            break;
          }
          default: {
            console.log('ERROR IN MESSAGE TYPE')
          }
        }
      })
    })

 
		if (typeof connection.sendCustomMessage === 'undefined') {
			connection.sendCustomMessage = function (message) {
				connection.socket.emit(connection.socketCustomEvent, message);
			};

			connection.connectSocket(function () {
				connection.socket.on(connection.socketCustomEvent, function (message) {
					if (typeof connection.onCustomMessage === 'function') {
						connection.onCustomMessage(message);
					} else {
						console.log('custom message received that is not a function.')
            console.log(message)
						
					}
				});
			
			});
		}
  }




  constructor(private settingsService: SettingsService ) { 
        this.init();
        this.settings = settingsService;
    
        this.screenshareActive = false;
  
       
       
 
  }


}
